<!-- Sidebar Header starts -->
<div class="sidebar-header">
  <div class="logo clearfix">
    <a [routerLink]="['/']" class="logo-text float-left">
      <!-- <div class="logo-img">
      <img [src]="logoUrl" />
    </div> -->
    <span class="text align-middle">TL-CMS</span>
  </a>
  <a
    class="nav-toggle d-none d-sm-none d-md-none d-lg-block"
    id="sidebarToggle"
    href="javascript:;"
    >
    <i
      #toggleIcon
      appSidebarToggle
      class="ft-toggle-right toggle-icon"
      data-toggle="expanded"
    ></i>
  </a>
  <a
    class="nav-close d-block d-md-block d-lg-none d-xl-none"
    id="sidebarClose"
    href="javascript:;"
    >
    <i class="ft-x"></i>
  </a>
</div>
</div>
<!-- Sidebar Header Ends -->

<!-- Sidebar Content starts -->
<ng-scrollbar class="sidebar-content">
  <div class="nav-container">
    <ul class="navigation" appSidebarList>
      <!-- First level menu -->
      @for (menuItem of menuItems; track menuItem) {
        <li
          appSidebarlink
          level="{{ depth + 1 }}"
          (toggleEmit)="handleToggle($event)"
          (click)="toggleSlideInOut()"
          [routePath]="menuItem.path"
          [classes]="menuItem.class"
          [title]="menuItem.title"
          [parent]=""
          [ngClass]="{
          'has-sub': menuItem.class === 'has-sub' ? true : false,
          open:
          activeTitles.includes(menuItem.title) && !navCollapsedOpen
          ? true
          : false,
          'nav-collapsed-open':
          navCollapsedOpen && activeTitles.includes(menuItem.title)
          }"
          [routerLinkActive]="menuItem.submenu.length !== 0 ? '' : 'active'"
          [routerLinkActiveOptions]="{ exact: true }"
          >
          @if (!menuItem.isExternalLink) {
            <a
              appSidebarAnchorToggle
              [routerLink]="menuItem.class === '' ? [menuItem.path] : null"
              >
              <i [ngClass]="[menuItem.icon]"></i>
              <span class="menu-title">{{ menuItem.title | translate }}</span>
              @if (menuItem.badge !== '') {
                <span
                  [ngClass]="[menuItem.badgeClass]"
                  >{{ menuItem.badge }}</span
                  >
                }
              </a>
            } @else {
              <a [href]="[menuItem.path]" target="_blank">
                <i [ngClass]="[menuItem.icon]"></i>
                <span class="menu-title">{{ menuItem.title | translate }}</span>
                @if (menuItem.badge !== '') {
                  <span
                    [ngClass]="[menuItem.badgeClass]"
                    >{{ menuItem.badge }}</span
                    >
                  }
                </a>
              }
              <!-- Second level menu -->
              @if (menuItem.submenu.length > 0) {
                <ul
                  class="menu-content"
                  [@slideInOut]="activeTitles.includes(menuItem.title) ? true : false"
                  >
                  @for (menuSubItem of menuItem.submenu; track menuSubItem) {
                    <li
                      appSidebarlink
                      level="{{ depth + 2 }}"
                      (toggleEmit)="handleToggle($event)"
                      [routePath]="menuSubItem.path"
                      [classes]="menuSubItem.class"
                      [title]="menuSubItem.title"
                      [parent]="menuItem.title"
                      [routerLinkActive]="menuSubItem.submenu.length > 0 ? '' : 'active'"
                      [ngClass]="{
                      'has-sub': menuSubItem.class === 'has-sub' ? true : false,
                      open:
                      activeTitles.includes(menuSubItem.title) && !navCollapsedOpen
                      ? true
                      : false,
                      'nav-collapsed-open':
                      navCollapsedOpen && activeTitles.includes(menuSubItem.title)
                      }"
                      >
                      @if (!menuSubItem.isExternalLink) {
                        <a
                          appSidebarAnchorToggle
                          [routerLink]="
                          menuSubItem.submenu.length > 0 ? null : [menuSubItem.path]
                          "
                          >
                          <i [ngClass]="[menuSubItem.icon]"></i>
                          <span class="menu-title">{{
                            menuSubItem.title | translate
                          }}</span>
                          @if (menuSubItem.badge !== '') {
                            <span
                              [ngClass]="[menuSubItem.badgeClass]"
                              >{{ menuSubItem.badge }}</span
                              >
                            }
                          </a>
                        } @else {
                          <a [href]="[menuSubItem.path]">
                            <i [ngClass]="[menuSubItem.icon]"></i>
                            <span class="menu-title">{{
                              menuSubItem.title | translate
                            }}</span>
                            @if (menuSubItem.badge !== '') {
                              <span
                                [ngClass]="[menuSubItem.badgeClass]"
                                >{{ menuSubItem.badge }}</span
                                >
                              }
                            </a>
                          }
                          <!-- Third level menu -->
                          @if (menuSubItem.submenu.length > 0) {
                            <ul
                              class="menu-content"
                              [@slideInOut]="
                              activeTitles.includes(menuSubItem.title) ? true : false
                              "
                              >
                              @for (menuSubsubItem of menuSubItem.submenu; track menuSubsubItem) {
                                <li
                                  appSidebarlink
                                  level="{{ depth + 3 }}"
                                  [routePath]="menuSubsubItem.path"
                                  [classes]="menuSubsubItem.class"
                                  [title]="menuSubsubItem.title"
                                  [parent]="menuSubItem.title"
                                  routerLinkActive="active"
                                  [routerLinkActiveOptions]="{ exact: true }"
                                  [ngClass]="[menuSubsubItem.class]"
                                  >
                                  @if (
                                    !menuSubsubItem.isExternalLink) {
                                    <a
                                      appSidebarAnchorToggle
                                      [routerLink]="[menuSubsubItem.path]"
                                      >
                                      <i [ngClass]="[menuSubsubItem.icon]"></i>
                                      <span class="menu-title">{{
                                        menuSubsubItem.title | translate
                                      }}</span>
                                      @if (menuSubsubItem.badge !== '') {
                                        <span
                                          [ngClass]="[menuSubsubItem.badgeClass]"
                                          >{{ menuSubsubItem.badge }}</span
                                          >
                                        }
                                      </a>
                                    } @else {
                                      <a [href]="[menuSubsubItem.path]">
                                        <i [ngClass]="[menuSubsubItem.icon]"></i>
                                        <span class="menu-title">{{
                                          menuSubsubItem.title | translate
                                        }}</span>
                                        @if (menuSubsubItem.badge !== '') {
                                          <span
                                            [ngClass]="[menuSubsubItem.badgeClass]"
                                            >{{ menuSubsubItem.badge }}</span
                                            >
                                          }
                                        </a>
                                      }
                                    </li>
                                  }
                                </ul>
                              }
                            </li>
                          }
                        </ul>
                      }
                    </li>
                  }
                </ul>
              </div>
            </ng-scrollbar>
            <!-- Sidebar Content Ends -->
